module.exports = __webpack_public_path__ + "img/stubbed-messages.8f8a5aa2.png";